import React, { useEffect, useState } from "react";
import "./admin.css";
import axios from "axios";

export default function Admin({ user }) {
  const [menu, setMenu] = useState(1);
  return (
    <div className="admin">
      <div className="sidebar">
        <div
          className="sidebar-item"
          onClick={() => {
            setMenu(1);
          }}
        >
          Projects
        </div>
        <div
          className="sidebar-item"
          onClick={() => {
            setMenu(2);
          }}
        >
          Skills
        </div>
        <div
          className="sidebar-item"
          onClick={() => {
            setMenu(3);
          }}
        >
          Experience
        </div>
      </div>
      <div className="admin-window">
        {menu === 1 && <Projects user={user} />}
        {menu === 2 && <Skills user={user} />}
        {menu === 3 && <Experience user={user} />}
      </div>
    </div>
  );
}

function Projects({ user }) {
  const [mode, setMode] = useState("new");
  const [title, setTitle] = useState();
  const [label, setLabel] = useState();
  const [desc, setDesc] = useState();
  const [tech, setTech] = useState();
  const [img, setImg] = useState();
  const [link, setLink] = useState();
  const [tag, setTag] = useState();
  const [index, setIndex] = useState(-1);

  async function handleSubmit() {
    if (mode === "new") {
      console.log("first");
      // const res = await axios.put(`http://localhost:4000/updateproject`, [
      const res = await axios.put(`/updateproject`, [
        ...projects,
        {
          title: title,
          cat_label: label,
          desc: desc,
          tech: tech,
          bg_img: img,
          link: link,
          tag: tag,
        },
      ]);
      window.alert("Project Added");
    } else {
      let arr = [...projects];
      arr[index] = {
        title: title,
        cat_label: label,
        desc: desc,
        tech: tech,
        bg_img: img,
        link: link,
        tag: tag,
      };
      // const res = await axios.put(`http://localhost:4000/updateproject`, arr);
      const res = await axios.put(`/updateproject`, arr);
      window.alert("Project Updated");
    }
  }

  async function handleDelete(index) {
    if (window.confirm("Are you sure?")) {
      let newArr = [...projects];
      newArr.splice(index, 1);
      // const res = await axios.put(
      //   `http://localhost:4000/updateproject`,
      //   newArr
      // );
      const res = await axios.put(`/updateproject`, newArr);
      window.alert("Deleted");
    }
  }

  async function handleUpdate() {
    // const res = await axios.put(
    //   `http://localhost:4000/updateproject`,
    //   projects
    // );
    const res = await axios.put(`/updateproject`, projects);
    window.alert("Project Updated");
  }

  const [projects, setProjects] = useState(user.projects);

  function moveUp(index) {
    let arr = [...projects];
    let temp = arr[index];
    arr[index] = arr[index - 1];
    arr[index - 1] = temp;
    setProjects(arr);
  }
  function moveDown(index) {
    let arr = [...projects];
    let temp = arr[index];
    arr[index] = arr[index + 1];
    arr[index + 1] = temp;
    setProjects(arr);
  }

  return (
    <div className="admin-projects">
      <div className="admin-project-form">
        <h2>{mode === "new" ? "Add New Project" : "Edit Project"}</h2>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <div>
            <input
              type="text"
              placeholder="Project Title"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            ></input>
          </div>
          <div>
            <input
              type="text"
              placeholder="Technology (Comma and space separated)"
              value={tech}
              onChange={(e) => {
                setTech(e.target.value);
              }}
            ></input>
          </div>
          <div>
            <input
              type="text"
              placeholder="Filter Label Text"
              value={label}
              onChange={(e) => {
                setLabel(e.target.value);
              }}
            ></input>
          </div>
          <div>
            <input
              type="text"
              placeholder="Background Img Url"
              value={img}
              onChange={(e) => {
                setImg(e.target.value);
              }}
            ></input>
          </div>
          <div>
            <input
              placeholder="Project Link"
              value={link}
              onChange={(e) => {
                setLink(e.target.value);
              }}
            ></input>
          </div>
          <div>
            <input
              placeholder="Keywords"
              value={tag}
              onChange={(e) => {
                setTag(e.target.value);
              }}
            ></input>
          </div>
          <div style={{ gridColumn: "1/3" }}>
            <textarea
              placeholder="Project Description"
              value={desc}
              onChange={(e) => {
                setDesc(e.target.value);
              }}
            ></textarea>
          </div>
          <div
            style={{
              gridColumn: "1/3",
              display: "flex",
              alignItems: "center",
              gap: "20px",
              justifyContent: "center",
            }}
          >
            <input
              type="Submit"
              value={mode === "new" ? "Add" : "Update"}
            ></input>
            {mode !== "new" && (
              <input
                type="button"
                value="Cancel"
                style={{ width: "200px" }}
                onClick={() => {
                  setMode("new");
                  setTitle("");
                  setDesc("");
                  setLabel("");
                  setTech("");
                  setImg("");
                  setLink("");
                  setTag("");
                  setIndex(-1);
                }}
              ></input>
            )}
          </div>
        </form>
      </div>
      {projects.map((item, index) => (
        <div className="admin-project-row">
          <div className="admin-project-name">{item.title}</div>
          <div className="admin-project-actions">
            <button
              onClick={() => {
                setMode("edit");
                setTitle(item.title);
                setDesc(item.desc);
                setLabel(item.cat_label);
                setTech(item.tech);
                setImg(item.bg_img);
                setLink(item.link);
                setTag(item.tag);
                setIndex(index);
              }}
            >
              Edit
            </button>
            <button
              onClick={() => {
                handleDelete(index);
              }}
            >
              Delete
            </button>
            <button
              disabled={index === 0}
              onClick={() => {
                moveUp(index);
              }}
            >
              Move up
            </button>
            <button
              disabled={index === projects.length - 1}
              onClick={() => {
                moveDown(index);
              }}
            >
              Move down
            </button>
          </div>
        </div>
      ))}
      <div className="save-btn">
        <button
          onClick={() => {
            handleUpdate();
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
}

function Skills({ user }) {
  const [mode, setMode] = useState("new");
  const [name, setName] = useState();
  const [icon, setIcon] = useState();
  const [index, setIndex] = useState(-1);

  async function handleSubmit() {
    if (mode === "new") {
      // const res = await axios.put(`http://localhost:4000/updateskill`, [
      const res = await axios.put(`/updateskill`, [
        ...skills,
        {
          name: name,
          icon: icon,
        },
      ]);
      window.alert("Skill Added");
    } else {
      let arr = [...skills];
      arr[index] = {
        name: name,
        icon: icon,
      };
      // const res = await axios.put(`http://localhost:4000/updateskill`, arr);
      const res = await axios.put(`/updateskill`, arr);
      window.alert("Skill Updated");
    }
  }

  async function handleDelete(index) {
    if (window.confirm("Are you sure?")) {
      let newArr = [...skills];
      newArr.splice(index, 1);
      // const res = await axios.put(`http://localhost:4000/updateskill`, newArr);
      const res = await axios.put(`/updateskill`, newArr);
      window.alert("Deleted");
    }
  }

  async function handleUpdate() {
    // const res = await axios.put(`http://localhost:4000/updateskill`, skills);
    const res = await axios.put(`/updateskill`, skills);
    window.alert("Skills Updated");
  }

  const [skills, setSkills] = useState(user.skills);

  function moveUp(index) {
    let arr = [...skills];
    let temp = arr[index];
    arr[index] = arr[index - 1];
    arr[index - 1] = temp;
    setSkills(arr);
  }
  function moveDown(index) {
    let arr = [...skills];
    let temp = arr[index];
    arr[index] = arr[index + 1];
    arr[index + 1] = temp;
    setSkills(arr);
  }

  return (
    <div className="admin-projects">
      <div className="admin-project-form">
        <h2>{mode === "new" ? "Add New Skill" : "Edit Skill"}</h2>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <div style={{ gridColumn: "1/3" }}>
            <input
              type="text"
              placeholder="Technology"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
              required
            ></input>
          </div>
          <div style={{ gridColumn: "1/3" }}>
            <input
              placeholder="Icon Link"
              value={icon}
              onChange={(e) => {
                setIcon(e.target.value);
              }}
              required
            ></input>
          </div>
          <div
            style={{
              gridColumn: "1/3",
              display: "flex",
              alignItems: "center",
              gap: "20px",
              justifyContent: "center",
            }}
          >
            <input
              type="Submit"
              value={mode === "new" ? "Add" : "Update"}
            ></input>
            {mode !== "new" && (
              <input
                type="button"
                value="Cancel"
                style={{ width: "200px" }}
                onClick={() => {
                  setMode("new");
                  setName("");
                  setIcon("");
                  setIndex(-1);
                }}
              ></input>
            )}
          </div>
        </form>
      </div>
      {skills.map((item, index) => (
        <div className="admin-project-row">
          <div className="admin-project-name">
            <img
              src={item.icon}
              alt=""
              style={{ height: "30px", marginRight: "20px" }}
            ></img>
            {item.name}
          </div>
          <div className="admin-project-actions">
            <button
              onClick={() => {
                setMode("edit");
                setName(item.name);
                setIcon(item.icon);
                setIndex(index);
              }}
            >
              Edit
            </button>
            <button
              onClick={() => {
                handleDelete(index);
              }}
            >
              Delete
            </button>
            <button
              disabled={index === 0}
              onClick={() => {
                moveUp(index);
              }}
            >
              Move up
            </button>
            <button
              disabled={index === skills.length - 1}
              onClick={() => {
                moveDown(index);
              }}
            >
              Move down
            </button>
          </div>
        </div>
      ))}
      <div className="save-btn">
        <button
          onClick={() => {
            handleUpdate();
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
}

function Experience({ user }) {
  const [mode, setMode] = useState("new");
  const [role, setRole] = useState();
  const [org, setOrg] = useState();
  const [loc, setLoc] = useState();
  const [duration, setDuration] = useState();
  const [resp, setResp] = useState();
  const [tech, setTech] = useState();
  const [img, setImg] = useState();
  const [index, setIndex] = useState(-1);

  const [exp, setExp] = useState(user.work_experience);

  async function handleSubmit() {
    if (mode === "new") {
      // const res = await axios.put(`http://localhost:4000/updateexperience`, [
      const res = await axios.put(`/updateexperience`, [
        ...exp,
        {
          role,
          org,
          loc,
          duration,
          resp,
          tech,
          bg_img: img,
        },
      ]);
      window.alert("Experience Added");
    } else {
      let arr = [...exp];
      arr[index] = {
        role,
        org,
        loc,
        duration,
        resp,
        tech,
        bg_img: img,
      };
      // const res = await axios.put(`http://localhost:4000/updateexperience`, arr);
      const res = await axios.put(`/updateexperience`, arr);
      window.alert("Experience Updated");
    }
  }

  async function handleDelete(index) {
    if (window.confirm("Are you sure?")) {
      let newArr = [...exp];
      newArr.splice(index, 1);
      // const res = await axios.put(
      //   `http://localhost:4000/updateexperience`,
      //   newArr
      // );
      const res = await axios.put(`/updateexperience`, newArr);
      window.alert("Deleted");
    }
  }

  async function handleUpdate() {
    // const res = await axios.put(
    //   `http://localhost:4000/updateexperience`,
    //   exp
    // );
    const res = await axios.put(`/updateexperience`, exp);
    window.alert("Experience Updated");
  }

  function moveUp(index) {
    let arr = [...exp];
    let temp = arr[index];
    arr[index] = arr[index - 1];
    arr[index - 1] = temp;
    setExp(arr);
  }
  function moveDown(index) {
    let arr = [...exp];
    let temp = arr[index];
    arr[index] = arr[index + 1];
    arr[index + 1] = temp;
    setExp(arr);
  }

  return (
    <div className="admin-projects">
      <div className="admin-project-form">
        <h2>{mode === "new" ? "Add New Experience" : "Edit Experience"}</h2>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <div>
            <input
              type="text"
              placeholder="Job Profile"
              value={role}
              onChange={(e) => {
                setRole(e.target.value);
              }}
            ></input>
          </div>
          <div>
            <input
              type="text"
              placeholder="Organisation"
              value={org}
              onChange={(e) => {
                setOrg(e.target.value);
              }}
            ></input>
          </div>
          <div>
            <input
              type="text"
              placeholder="Location (City, State)"
              value={loc}
              onChange={(e) => {
                setLoc(e.target.value);
              }}
            ></input>
          </div>
          <div>
            <input
              type="text"
              placeholder="Duration (MON YYYY - MON YYYY)"
              value={duration}
              onChange={(e) => {
                setDuration(e.target.value);
              }}
            ></input>
          </div>
          <div>
            <input
              placeholder="Roles & Responsibilities"
              value={resp}
              onChange={(e) => {
                setResp(e.target.value);
              }}
            ></input>
          </div>
          <div>
            <input
              placeholder="Technologies (Comma Separated)"
              value={tech}
              onChange={(e) => {
                setTech(e.target.value.split(","));
                console.log(e.target.value.split(","));
              }}
            ></input>
          </div>
          <div style={{ gridColumn: "1/3" }}>
            <input
              placeholder="Background Image Link"
              value={img}
              onChange={(e) => {
                setImg(e.target.value);
              }}
            ></input>
          </div>
          <div
            style={{
              gridColumn: "1/3",
              display: "flex",
              alignItems: "center",
              gap: "20px",
              justifyContent: "center",
            }}
          >
            <input
              type="Submit"
              value={mode === "new" ? "Add" : "Update"}
            ></input>
            {mode !== "new" && (
              <input
                type="button"
                value="Cancel"
                style={{ width: "200px" }}
                onClick={() => {
                  setMode("new");
                  setRole("");
                  setOrg("");
                  setLoc("");
                  setDuration("");
                  setResp("");
                  setTech("");
                  setImg("");
                  setIndex(-1);
                }}
              ></input>
            )}
          </div>
        </form>
      </div>
      {exp.map((item, index) => (
        <div className="admin-project-row">
          <div className="admin-project-name">{item.org}</div>
          <div className="admin-project-actions">
            <button
              onClick={() => {
                setMode("edit");
                setRole(item.role);
                setOrg(item.org);
                setLoc(item.loc);
                setDuration(item.duration);
                setResp(item.resp);
                setTech(item.tech);
                setImg(item.bg_img);
                setIndex(index);
              }}
            >
              Edit
            </button>
            <button
              onClick={() => {
                handleDelete(index);
              }}
            >
              Delete
            </button>
            <button
              disabled={index === 0}
              onClick={() => {
                moveUp(index);
              }}
            >
              Move up
            </button>
            <button
              disabled={index === exp.length - 1}
              onClick={() => {
                moveDown(index);
              }}
            >
              Move down
            </button>
          </div>
        </div>
      ))}
      <div className="save-btn">
        <button
          onClick={() => {
            handleUpdate();
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
}
